import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useComponentId } from '@indriver/whisperwind';
import { Box } from './loader.styles.js';

var _stop, _stop2, _stop3, _stop4, _path;

var _excluded = ["design", "size"];
var sizes = {
  xxs: 12,
  xs: 16,
  s: 20,
  m: 24,
  l: 32,
  xl: 40
};
var Loader = function Loader(props) {
  var _props$design = props.design,
      design = _props$design === void 0 ? 'brand' : _props$design,
      _props$size = props.size,
      size = _props$size === void 0 ? 'm' : _props$size,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var diam = sizes[size];
  var firstHalfID = useComponentId({
    prefix: 'loader–first-half'
  });
  var secondHalfID = useComponentId({
    prefix: 'loader–second-half'
  });
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    role: "alert",
    "aria-hidden": "true"
  }, attrs, {
    width: diam,
    height: diam,
    design: design,
    viewBox: "-2 -2 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: firstHalfID
  }, _stop || (_stop = /*#__PURE__*/React__default.createElement("stop", {
    offset: "0%",
    stopOpacity: "0",
    stopColor: "currentColor"
  })), _stop2 || (_stop2 = /*#__PURE__*/React__default.createElement("stop", {
    offset: "100%",
    stopOpacity: "0.5",
    stopColor: "currentColor"
  }))), /*#__PURE__*/React__default.createElement("linearGradient", {
    gradientTransform: "translate(-0.1, 0)",
    id: secondHalfID
  }, _stop3 || (_stop3 = /*#__PURE__*/React__default.createElement("stop", {
    offset: "0%",
    stopOpacity: "1",
    stopColor: "currentColor"
  })), _stop4 || (_stop4 = /*#__PURE__*/React__default.createElement("stop", {
    offset: "100%",
    stopOpacity: "0.5",
    stopColor: "currentColor"
  })))), /*#__PURE__*/React__default.createElement("g", {
    strokeWidth: "6"
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "url(#" + firstHalfID + ")",
    d: "M18 9.5C18 8.38376 17.7801 7.27846 17.353 6.24719C16.9258 5.21592 16.2997 4.27889 15.5104 3.48959C14.7211 2.70029 13.7841 2.07419 12.7528 1.64702C11.7215 1.21986 10.6162 1 9.5 1C8.38376 1 7.27846 1.21986 6.24719 1.64702C5.21592 2.07419 4.27889 2.70029 3.48959 3.48959C2.70029 4.27889 2.07419 5.21592 1.64702 6.24719C1.21986 7.27846 1 8.38376 1 9.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "url(#" + secondHalfID + ")",
    d: "M1 9.5C1 10.6162 1.21986 11.7215 1.64702 12.7528C2.07419 13.7841 2.70029 14.7211 3.48959 15.5104C4.27889 16.2997 5.21592 16.9258 6.24719 17.353C7.27846 17.7801 8.38376 18 9.5 18C10.6162 18 11.7215 17.7801 12.7528 17.353C13.7841 16.9258 14.7211 16.2997 15.5104 15.5104C16.2997 14.7211 16.9258 13.7841 17.353 12.7528C17.7801 11.7215 18 10.6162 18 9.5"
  }), _path || (_path = /*#__PURE__*/React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M1 10V10.3"
  }))));
};
Loader.displayName = 'Loader';

export { Loader, Loader as default };
